export default "__VITE_ASSET__cYjnneir__"